export const PRODUCT_FORM_FIELD_CLASS =
  'h-[38px] w-full rounded-[8px] border border-[#EDF1F7] bg-white px-[11px] text-[13px] font-medium text-[#101828] outline-none transition-colors focus:border-brand disabled:cursor-not-allowed disabled:opacity-60';

export const PRODUCT_FORM_TEXTAREA_CLASS =
  'w-full rounded-[8px] border border-[#EDF1F7] bg-white px-[11px] py-2 text-[13px] font-medium text-[#101828] outline-none transition-colors focus:border-brand disabled:cursor-not-allowed disabled:opacity-60';

export const PRODUCT_FORM_LABEL_CLASS =
  'text-[13px] font-semibold leading-none tracking-[-0.2px] text-[#0F172B]';

export const PRODUCT_FORM_REQUIRED_CLASS = 'ml-1 text-[#E11D48]';

export const PRODUCT_FORM_ROW_CLASS = 'flex-1 min-w-0 flex flex-col gap-1.5';

export const PRODUCT_FORM_INLINE_BUTTON_CLASS =
  'inline-flex h-[38px] shrink-0 items-center rounded-[8px] border border-[#EDF1F7] bg-white px-3 text-[13px] font-medium text-[#101828] transition-colors hover:bg-[#F9FAFB]';
